import React from 'react';
import {SitesHeaderProps} from "../../../../@types/types";

const SitesHeader: React.FC <SitesHeaderProps> = (props: SitesHeaderProps) => {
    const {children} = props;

    return (
        <div className='sites-header'>
            <div className='sites-header--search'>
                {children}
            </div>
        </div>
    );
}

export default SitesHeader;
